import { render, staticRenderFns } from "./set-new-password.vue?vue&type=template&id=8c450bf2&scoped=true&"
import script from "./set-new-password.vue?vue&type=script&lang=js&"
export * from "./set-new-password.vue?vue&type=script&lang=js&"
import style0 from "./set-new-password.vue?vue&type=style&index=0&id=8c450bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c450bf2",
  null
  
)

export default component.exports